// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__lKNoj","header":"ClearentDisclaimer_header__17SMi","inner":"ClearentDisclaimer_inner__1t22x"};